<div class="pageId_Home biggerFont" xmlns:margin-left="http://www.w3.org/1999/xhtml">
  <div *transloco="let t">
    <mat-card class="p-0 lazy-loading-min-height-500">
      <div id="home">
        <app-dynamic-image [mode]="'FLEX'">
          <div class="flex-container">
            <h1 class="bannerTitle" data-translate="banner.genericTitle">{{ t("products.banner.genericTitle") }}</h1>
            <h1 class="bannerTitle" data-translate="banner.genericTitle2">{{ t("products.banner.genericTitle2") }}</h1>
            <h3 class="bannerTitle" data-translate="banner.genericTitle3">{{ t("products.banner.genericTitle3") }}</h3>

            <!--            <a-->
            <!--              *ngIf="langKey === 'de-CH'"-->
            <!--              class="kw-new-product kw-new-product-2 btn-xlg btn-primary-kw"-->
            <!--              rel="noopener"-->
            <!--              target="_blank"-->
            <!--              href="https://bautrends.ch/messe-luzern/de/fuer-besucher-uebersicht-sonderschauen"-->
            <!--            >-->
            <!--              <span class="new-product-lcc" [innerHTML]="t('products.banner.new-2')"></span>-->
            <!--            </a>-->
            <a class="kw-new-product kw-new-product-2 btn-xlg btn-primary-kw" (click)="scroll(sectionId_lca)">
              <span class="new-product-lcc" [innerHTML]="t('products.banner.new-3')"></span>
            </a>

            <a
              class="kw-new-product kw-new-product-3 btn btn-xlg"
              href="https://www.digitalrealestate.ch/top-10-digital-real-estate-projekte-2023/"
              target="_blank"
            >
              <img class="kw-new-product-3" src="/assets/images/digital-top-4.png" />
            </a>

            <a
              style="font-size: 26px"
              class="kw-new-product btn btn-xlg"
              href="https://www.digitalrealestate.ch/top-10-digital-real-estate-projekte-2022/"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 152 223">
                <defs>
                  <style>
                    .a {
                      fill: none;
                    }

                    .b {
                      clip-path: url(#a);
                    }

                    .c {
                      fill: url(#b);
                    }

                    .d,
                    .k,
                    .l,
                    .m,
                    .n,
                    .o,
                    .p,
                    .q,
                    .r,
                    .s,
                    .t,
                    .u,
                    .v,
                    .w,
                    .x,
                    .y {
                      fill: #fff;
                    }

                    .e {
                      clip-path: url(#c);
                    }

                    .f {
                      clip-path: url(#e);
                    }

                    .g {
                      clip-path: url(#g);
                    }

                    .h {
                      fill: #fffded;
                    }

                    .i {
                      font-size: 20.98px;
                      fill: #c30b6c;
                    }

                    .i,
                    .k,
                    .l,
                    .m,
                    .n,
                    .o,
                    .p,
                    .q,
                    .r,
                    .s,
                    .t,
                    .u,
                    .v,
                    .w,
                    .x,
                    .y {
                      font-family:
                        MyriadPro-Regular,
                        Myriad Pro;
                    }

                    .j {
                      letter-spacing: -0.07em;
                    }

                    .k {
                      font-size: 14.87px;
                    }

                    .l {
                      font-size: 14.87px;
                    }

                    .m {
                      font-size: 14.87px;
                    }

                    .n {
                      font-size: 14.87px;
                    }

                    .o {
                      font-size: 14.87px;
                    }

                    .p {
                      font-size: 14.87px;
                    }

                    .q {
                      font-size: 14.87px;
                    }

                    .r {
                      font-size: 14.87px;
                    }

                    .s {
                      font-size: 14.87px;
                    }

                    .t {
                      font-size: 14.87px;
                    }

                    .u {
                      font-size: 14.87px;
                    }

                    .v {
                      font-size: 14.87px;
                    }

                    .w {
                      font-size: 14.87px;
                    }

                    .x {
                      font-size: 14.87px;
                    }

                    .y {
                      font-size: 14.87px;
                    }
                  </style>
                  <clipPath id="a">
                    <polygon class="a" points="33.5 81.7 33.5 221.4 75.9 199.7 118.3 221.4 118.3 81.7 33.5 81.7" />
                  </clipPath>
                  <linearGradient
                    id="b"
                    x1="-397.86"
                    y1="511.34"
                    x2="-396.86"
                    y2="511.34"
                    gradientTransform="matrix(84.8, 0, 0, -84.8, 33774.21, 43515.52)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stop-color="#009f60" />
                    <stop offset="0.49" stop-color="#009ee3" />
                    <stop offset="1" stop-color="#c3006b" />
                  </linearGradient>
                  <clipPath id="c">
                    <rect class="a" x="5.4" y="2.7" width="141.9" height="141.91" />
                  </clipPath>
                  <clipPath id="e">
                    <path
                      class="a"
                      d="M35.1,73.7a41.3,41.3,0,1,1,41.3,41.2A41.3,41.3,0,0,1,35.1,73.7M66.5,7.9l-7-3.3-4.6,6.1-7.4-2L44,15.5l-7.7-.6-2.2,7.3-7.6.7-.9,7.7-7.4,2,.6,7.7-6.9,3.4,1.8,7.4L7.5,55.6l3.2,7L5.4,68.2l4.4,6.3L5.6,80.9,11,86.4l-2.9,7,6.3,4.4-1.7,7.5,7,3.2-.3,7.6,7.4,1.9,1.1,7.6,7.6.5,2.4,7.3,7.7-.8,3.6,6.7,7.4-2.2,4.8,6,6.8-3.5,5.8,5,6.1-4.6,6.7,3.9,5.1-5.7,7.2,2.7,4.1-6.5,7.6,1.3,2.8-7.1h7.7l1.5-7.5,7.6-1.4.2-7.6,7.1-2.8-1.2-7.6,6.6-3.9-2.5-7.3,5.7-5-3.8-6.7,4.8-6-4.9-5.9L146,60l-5.9-4.9,2.3-7.3L135.8,44l1-7.6-7.3-2.6-.4-7.6L121.6,25l-1.8-7.5-7.7.2-3-7.1-7.5,1.6L97.3,5.8,90.2,8.6,84.9,3.1,78.4,7.2,72.1,2.7Z"
                    />
                  </clipPath>
                  <clipPath id="g">
                    <rect class="a" x="1.1" y="-1.7" width="150.6" height="150.66" />
                  </clipPath>
                  <image
                    id="h"
                    width="592"
                    height="593"
                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlAAAAJRCAYAAACKvongAAAACXBIWXMAAC4jAAAuIwF4pT92AAAOGklEQVR4Xu3WO7LbyAFA0caTPOnswNHk3sCswIlTL8XhrMWJ1+MFWe2ABAmAIPmupKpJzqliEWg0Gp9Hqe7yx3//M8dYxt12+2ysbh/257NjL8751NqfmXO2/yPb33vss/NeHfsZ845j7+b+jGu82q77765z3P+R6x7HfmStZYz56vjZ2J+9/87ugZ4Mncz51LHVfDLt1bW/85rz2bF5uvls8OP6+TLm+DLG+DIub/ZjjPEx1+15G1tun8vYcl1uefjMk2P3a+/G5n1/bNZex9f567Hd/u0a+/HLuYe5Y4wx59M1x9g/z/qujmO7X948nL9+z8exx/Hr9vYZdtcat7/z/pr7e1ifa2t7/vadXI7tr3t7pnf7m7Hb+9nuz82Eub3n+7zL3P3+GPffyvaU47ztu3v4/c+T57rez/5Zxu7c/ZrXse11N+/g9kyHsXVz+5t5OH8e7mPed5bj2HZ/fYaHsXFZ8zg+5xjfLtu//v7bWMa//3G7tcv348///fFX8w9j82y9utbZnO9dc91+N+fdPX3meq/mvlvr3fHV2f2++y7zr9tzO/7unM/e//E5nn2/O/9nnfPs+zPrvTq2XP+Rvlvj3fdn5hzv+92c7ffqsH8aF2dj42Tu8X++Z/NO5uz+83x1/ot547PzxufWfPp8l+2vY4y/jDF+mXP8Msb4ZVxC6eu4RNXXOa5hNa+xNcfHHPftMcYy9+PLZt6yzrmOLXP9Sz+Or6G2jDGWua59ud/t+HK2vxu/x91yWPNs7vrOjsfG2fzt8c11Xp2/jaDb88w5boG3Hbv+eZazczZrno2dhcF9zZO1n6zx7Ptyznat6/e8v8fb+1y3N+eczntY63qT83p/23Nux+Zue4z1Gcb+fuc4rLlZ5/AOtuuv191d8zD+9DrzstiymXebfxh7fK7NNb89rr1sxsYcY3zbjH0b188cy/8u33/919/HxwAAIBFQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEAkoAIBIQAEARAIKACASUAAAkYACAIgEFABAJKAAACIBBQAQCSgAgEhAAQBEAgoAIBJQAACRgAIAiAQUAEAkoAAAIgEFABAJKACASEABAEQCCgAgElAAAJGAAgCIBBQAQCSgAAAiAQUAEH3942//HGMsm6Ht9tlY3T7sz2fHXpzzqbU/M+ds/0e2v/fYZ+e9OvYz5h3H3s39Gdd4tV33313nuP8j1z2O/chayxjz1fGzsT97/53dAz0ZOpnzqWOr+WTaq2t/5zXns2PzdPPZ4Mf182XM8WWM8WVc3uzHGONjrtvzNrbcPpex5brc8vCZJ8fu196Nzfv+2Ky9jq/z12O7/ds19uOXcw9zxxhjzqdrjrF/nvVdHcd2v7x5OH/9no9jj+PX7e0z7K41bn/n/TX397A+19b2/O07uRzbX/f2TO/2N2O397Pdn5sJc3vP93mXufv9Me6/le0px3nbd/fw+58nz3W9n/2zjN25+zWvY9vrbt7B7ZkOY+vm9jfzcP483Me87yzHse3++gwPY+Oy5nF8zjG+XbZ//f238X+hfhkCDvpVTwAAAABJRU5ErkJggg=="
                  />
                </defs>
                <g class="b">
                  <polyline class="c" points="33.5 221.4 33.5 81.7 118.3 81.7 118.3 221.4" />
                  <polyline class="a" points="118.3 221.4 118.3 81.7 33.5 81.7 33.5 221.4" />
                  <polyline class="a" points="33.5 221.4 75.9 199.7 118.3 221.4" />
                  <polyline
                    class="d"
                    points="8.8 107.2 16.2 110.6 15.9 118.8 23.8 120.8 24.9 128.8 33 129.4 35.6 137.1 43.7 136.2 47.6 143.4 55.4 141 60.5 147.4 67.7 143.7 73.9 149 80.4 144.1 87.4 148.2 92.9 142.2 100.5 145 104.9 138.1 112.9 139.5 115.9 132 124.1 131.9 125.7 124 133.7 122.5 133.9 114.3 141.5 111.4 140.2 103.4 147.2 99.2 144.5 91.5 150.6 86.1 146.6 79 151.7 72.6 146.4 66.3 150.3 59.1 144 53.9 146.5 46.2 139.4 42.1 140.5 34.1 132.8 31.4 132.4 23.2 124.3 22 122.5 14 114.3 14.2 111.1 6.7 103.1 8.4 98.6 1.6"
                  />
                  <polyline
                    class="d"
                    points="45.7 4.7 42 11.9 33.9 11.2 31.5 19 23.4 19.8 22.5 27.9 14.7 30.1 15.2 38.2 7.9 41.8"
                  />
                  <polyline class="d" points="58.5 0.3 53.6 6.8 45.7 4.7" />
                  <g class="e">
                    <use transform="translate(5.4 2.5) scale(0.24)" xlink:href="#h" />
                  </g>
                  <path class="a" d="M35.1,73.7a41.3,41.3,0,1,1,41.3,41.2A41.3,41.3,0,0,1,35.1,73.7" />
                  <polyline class="a" points="72.1 2.7 66.5 7.9 59.5 4.6" />
                  <polyline class="a" points="84.9 3.1 78.4 7.2 72.1 2.7" />
                  <polyline
                    class="a"
                    points="12.7 105.3 19.7 108.5 19.4 116.1 26.8 118 27.9 125.6 35.5 126.1 37.9 133.4 45.6 132.6 49.2 139.3 56.6 137.1 61.4 143.1 68.2 139.6 74 144.6 80.1 140 86.8 143.9 91.9 138.2 99.1 140.9 103.2 134.4 110.8 135.7 113.6 128.6 121.3 128.5 122.8 121 130.4 119.6 130.6 112 137.7 109.2 136.5 101.6 143.1 97.7 140.6 90.4 146.3 85.4 142.5 78.7 147.3 72.7 142.4 66.8 146 60 140.1 55.1 142.4 47.8 135.8 44 136.8 36.4 129.5 33.8 129.1 26.2 121.6 25 119.8 17.5 112.1 17.7 109.1 10.6 101.6 12.2 97.3 5.8 90.2 8.6 84.9 3.1"
                  />
                  <polyline class="a" points="8.1 93.4 14.4 97.8 12.7 105.3" />
                  <polyline class="a" points="11.9 43.7 13.7 51.1 7.5 55.6" />
                  <polyline
                    class="a"
                    points="59.5 4.6 54.9 10.7 47.5 8.7 44 15.5 36.3 14.9 34.1 22.2 26.5 22.9 25.6 30.6 18.2 32.6 18.8 40.3 11.9 43.7"
                  />
                  <rect class="c" x="33.5" y="81.7" width="84.8" height="139.69" />
                </g>
                <polygon
                  class="d"
                  points="71.9 -1.7 65.8 3.8 58.5 0.3 53.6 6.8 45.7 4.7 42 11.9 33.9 11.2 31.5 19 23.4 19.8 22.5 27.9 14.7 30.1 15.2 38.2 7.9 41.8 9.9 49.7 3.3 54.5 6.7 62 1.1 67.9 5.7 74.6 1.3 81.4 7 87.1 3.8 94.7 10.5 99.3 8.8 107.2 16.2 110.6 15.9 118.8 23.8 120.8 24.9 128.8 33 129.4 35.6 137.1 43.7 136.2 47.6 143.4 55.4 141 60.5 147.4 67.7 143.7 73.9 149 80.4 144.1 87.4 148.2 92.9 142.2 100.5 145 104.9 138.1 112.9 139.5 115.9 132 124.1 131.9 125.7 124 133.7 122.5 133.9 114.3 141.5 111.4 140.2 103.4 147.2 99.2 144.5 91.5 150.6 86.1 146.6 79 151.7 72.6 146.4 66.3 150.3 59.1 144 53.9 146.5 46.2 139.4 42.1 140.5 34.1 132.8 31.4 132.4 23.2 124.3 22 122.5 14 114.3 14.2 111.1 6.7 103.1 8.4 98.6 1.6 91 4.6 85.4 -1.2 78.5 3.1 71.9 -1.7"
                />
                <g class="f">
                  <g class="e">
                    <use transform="translate(5.4 2.5) scale(0.24)" xlink:href="#h" />
                  </g>
                </g>
                <g class="g">
                  <path
                    class="h"
                    d="M135,70.8c-.6.9-1.1,2-1.7,2.9l1.7,3-3.4-.6-2.2,2.6-.7-3.4L125.5,74a20.2,20.2,0,0,1,3.2-1.8l.6-3.6,2.3,2.6,3.4-.4"
                  />
                  <path
                    class="h"
                    d="M27.2,70.8c-.6.9-1.1,2-1.6,2.9l1.6,3-3.4-.6-2.2,2.6-.7-3.4L17.7,74a20.2,20.2,0,0,1,3.2-1.8l.6-3.6,2.3,2.6,3.4-.4"
                  />
                </g>
                <text class="i" transform="translate(52.2 78.8)">
                  <tspan class="j">T</tspan>
                  <tspan x="9" y="0">op 3</tspan>
                </text>
                <text class="k" transform="translate(39.7 42.1) rotate(-43.4)">D</text>
                <text class="l" transform="matrix(0.81, -0.59, 0.59, 0.81, 46.77, 35.68)">i</text>
                <text class="m" transform="matrix(0.87, -0.49, 0.49, 0.87, 49.28, 33.68)">g</text>
                <text class="n" transform="translate(56.3 29.9) rotate(-22.6)">i</text>
                <text class="o" transform="matrix(0.95, -0.31, 0.31, 0.95, 59.26, 28.61)">t</text>
                <text class="p" transform="translate(63.6 27.1) rotate(-11)">a</text>
                <text class="q" transform="matrix(1, -0.09, 0.09, 1, 70.44, 25.88)">l</text>
                <text class="r" transform="translate(76.1 25.4) rotate(4)">T</text>
                <text class="s" transform="translate(82.1 25.7) rotate(11.6)">o</text>
                <text class="t" transform="translate(89.7 27.2) rotate(21.1)">p</text>
                <text class="l" transform="matrix(0.83, 0.56, -0.56, 0.83, 99.93, 31.53)">1</text>
                <text class="u" transform="matrix(0.74, 0.67, -0.67, 0.74, 105.98, 35.55)">0</text>
                <text class="v" transform="translate(59.9 130.1) rotate(12.5)">2</text>
                <text class="w" transform="matrix(1, 0.07, -0.07, 1, 68.26, 131.91)">0</text>
                <text class="x" transform="matrix(1, -0.07, 0.07, 1, 76.79, 132.46)">2</text>
                <text class="y" transform="translate(85.3 131.8) rotate(-12.4)">2</text>
              </svg>
            </a>

            <div style="margin-top: 20px; text-align: left">
              <button
                *ngIf="!isAuthenticated"
                style="border-top: 3px solid; border-left: 3px solid; border-right: 3px solid; border-bottom: 3px solid"
                class="btn btn-elegant-white-title btn-elegant-white btn-xlg"
                [routerLink]="'7tage'"
              >
                {{ t("products.use_free_month") }}
              </button>
            </div>
          </div>
        </app-dynamic-image>
      </div>
    </mat-card>

    <!--Quick Navigation-->
    <mat-card class="p-0 lazy-loading-min-height-100">
      <mat-card-content class="contact-container" style="padding: 0">
        <!-- <mat-card-title>Landing page for keevalue.</mat-card-title> -->
        <ul class="nav nav-pills nav-justified kv-nav">
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              anchor-smooth-scroll="sectionId_baukosten"
              role="tab"
              (click)="scroll(sectionId_baukosten)"
            >
              <img src="/assets/images/products/baukosten_termine.svg" />
              <figcaption>{{ t("products.start.quickNav.build") }}</figcaption>
            </a>
          </li>
          <ng-container *ngIf="hasInsuranceValues">
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" (click)="scroll(sectionId_versicherungswerte)" role="tab">
                <img src="/assets/images/products/versicherungswerte.svg" />
                <figcaption>
                  {{ t("products.start.quickNav.insuranceValue") }}
                </figcaption>
              </a>
            </li>
          </ng-container>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_umbaukosten)">
              <img src="/assets/images/products/rebuild_costs.svg" />
              <figcaption>{{ t("products.start.quickNav.rebuild") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_betriebskosten)">
              <img src="/assets/images/products/betriebskosten.svg" />
              <figcaption>{{ t("products.start.quickNav.bewk") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_lcc)">
              <img src="/assets/images/products/lebenszyklus.svg" />
              <figcaption>{{ t("products.start.quickNav.lcc") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_dienstleistungen)">
              <img src="/assets/images/products/dienstleistungen.svg" />
              <figcaption>{{ t("products.start.quickNav.services") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_about)">
              <img style="padding: 12px" src="/assets/images/logo_kennwerte.svg" />
              <figcaption>{{ t("products.start.quickNav.about") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scroll(sectionId_userfeedback)">
              <img src="/assets/images/prices/userfeedback.svg" />
              <figcaption>{{ t("products.start.quickNav.userfeedback") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              role="tab"
              anchor-smooth-scroll="sectionId_prices"
              role="tab"
              (click)="scroll(sectionId_prices)"
            >
              <img src="/assets/images/prices/einmalige_berechnung.svg" />
              <figcaption>{{ t("products.start.quickNav.prices") }}</figcaption>
            </a>
          </li>
        </ul>
      </mat-card-content>
    </mat-card>

    <!-- START CONTENT -->
    <ng-container #sectionId_webinar id="sectionId_webinar" class="lazy-loading-min-height-600">
      <app-webinar></app-webinar>
    </ng-container>
    <ng-container #sectionId_intro id="sectionId_intro" class="lazy-loading-min-height-500">
      <app-intro [isAuthenticated]="isAuthenticated"></app-intro>
    </ng-container>

    <!-- Content Bar 01 - Modul LCA rechner -->
    <div #sectionId_lca id="sectionId_lca" fragment="lca" class="lazy-loading-min-height-500">
      <app-lca
        [isAuthenticated]="isAuthenticated"
        [hasLcaCosts]="hasLcaCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-lca>
    </div>

    <!-- Content Bar 00 - Modul Planungsgrundlage -->
    <div #sectionId_pf id="sectionId_pf" fragment="pf" class="lazy-loading-min-height-500">
      <app-pf
        [isAuthenticated]="isAuthenticated"
        [hasModule]="hasPlanningFondations"
        (openBillingModal)="openBillingModal($event)"
      ></app-pf>
    </div>

    <!-- Content Bar 02 - Modul LCC -->
    <div #sectionId_lcc id="sectionId_lcc" fragment="lcc" class="lazy-loading-min-height-600">
      <app-lcc
        [isAuthenticated]="isAuthenticated"
        [hasLccCosts]="hasLccCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-lcc>
    </div>

    <!-- Content Bar 03 - Modul Neubaukostenrechner -->
    <div #sectionId_baukosten id="sectionId_baukosten" class="lazy-loading-min-height-500">
      <app-build
        [IsAuthenticated]="isAuthenticated"
        [hasBuildingCosts]="hasBuildingCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-build>
    </div>

    <!-- Content Bar 04 - Modul Umbaukosten -->
    <div #sectionId_umbaukosten id="sectionId_umbaukosten" class="lazy-loading-min-height-500">
      <app-rebuild
        [isAuthenticated]="isAuthenticated"
        [hasRebuildCosts]="hasRebuildCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-rebuild>
    </div>

    <!-- Content Bar 05 - Versicherungswerte -->
    <div #sectionId_versicherungswerte id="sectionId_versicherungswerte">
      <app-insurance [isAuthenticated]="isAuthenticated" [hasInsuranceCosts]="hasInsuranceValues"></app-insurance>
    </div>

    <!-- Content Bar 04 - bewk + pom+-->
    <div #sectionId_betriebskosten id="sectionId_betriebskosten" class="lazy-loading-min-height-600">
      <app-bewk
        [isAuthenticated]="isAuthenticated"
        [hasOperationalCosts]="hasOperationalCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-bewk>
    </div>

    <!-- Content Bar 05 - Dienstleistungen -->
    <div
      #sectionId_dienstleistungen
      id="sectionId_dienstleistungen"
      ng-include="'app/website_fragments/products/services.html'"
    >
      <app-services></app-services>
    </div>

    <!-- Content Bar 04 - About Us -->
    <!-- <div id="sectionId_about"></div>
      <div ui-view="about_us"></div> -->
    <div #sectionId_about id="sectionId_about">
      <app-about-us></app-about-us>
    </div>

    <ng-container> <app-team></app-team> </ng-container>

    <!-- Content Bar 05 - User Feedback -->
    <!-- <div id="sectionId_userfeedback"></div> -->
    <div #sectionId_userfeedback id="sectionId_userfeedback" class="sectionId_userfeedback sectionAnchor flexBoxOuter">
      <div class="flexBoxInner txt marginRight" style="hyphens: auto">
        <div style="margin-bottom: 26px">
          <h4>{{ t("products.start.quickNav.userfeedback") }}</h4>
        </div>
        <div>
          <h3 class="kennwertered" data-translate="userfeedback.headline">{{ t("products.userfeedback.headline") }}</h3>
        </div>
        <div class="ctPartImg" ng-style="ctPartImgStyle">
          <div class="cImage" id="cImage" style="height: 100px; display: inline-flex">
            <img
              style="height: 100px; width: 100px; float: left; vertical-align: center"
              class=""
              id="userImage"
              src="/assets/images/user-feedback/rb.jpg"
            />
            <p
              style="
                height: 100%;
                width: 50%;
                padding-top: 15px;
                padding-left: 5px;
                padding-right: 5px;
                display: inline-block;
              "
            >
              <label style="margin-bottom: 0px" data-translate="userfeedback.user">
                {{ t("products.userfeedback.user") }}</label
              >
              <br />
              <label class="clearLabel" data-translate="userfeedback.title">
                {{ t("products.userfeedback.title") }}</label
              >
              <label class="clearLabel" data-translate="userfeedback.position">
                {{ t("products.userfeedback.position") }}</label
              >
            </p>
            <div style="line-height: 100px; height: 100px; display: inline-block">
              <img
                id="userLogo"
                style="height: 35px; padding-bottom: 5px; border-radius: 0%; vertical-align: middle"
                src="/assets/images/user-feedback/logo.jpg"
              />
            </div>
          </div>
        </div>

        <div class="brightfont clearFloat">
          <p
            style="margin-top: 20px"
            data-translate="userfeedback.text1"
            [innerHTML]="t('products.userfeedback.text1')"
          ></p>
          <p
            style="margin-top: 20px"
            data-translate="userfeedback.text2"
            [innerHTML]="t('products.userfeedback.text2')"
          ></p>
        </div>
      </div>
      <div class="flexBoxInner img">
        <div class="centerImage centerImgVertically">
          <img id="userBuilding" src="/assets/images/user-feedback/gebaeude.jpg" style="align-self: center" />
        </div>
      </div>
      <!--<div class="img">-->
      <!--<img src="/assets/images/user-feedback/gebaeude.jpg" style="align-self: center; height: 600px;border-radius: 180px 0 0 180px;">-->
      <!--</div>-->
    </div>

    <mat-card id="sectionId_userfeedback2" class="info-section">
      <div class="sectionId_userfeedback2 flexBoxOuter">
        <div class="flexBoxInner img marginRight">
          <div class="centerImage center-img-box">
            <img src="/assets/images/user-feedback/2/gebaeude-small.jpg" />
          </div>
        </div>
        <div class="flexBoxInner txt marginRight align-inner">
          <div class="">
            <div>
              <mat-card-title class="keevalue-title kv-text-color">
                {{ t("products.userfeedback.2.headline") }}
              </mat-card-title>
            </div>
            <!-- <div>
                <mat-card-title class="sub-title kv-text-color"> {{ t('products.userfeedback.headline') }}
                </mat-card-title>
              </div> -->
            <div class="part-img-wrapper">
              <div class="kv-Image">
                <img class="user-img" id="userImage" src="/assets/images/user-feedback/2/am.jpg" />
                <p class="kv-inner-wrapper">
                  <label>{{ t("products.userfeedback.2.user") }}</label>
                  <label class="clearLabel">{{ t("products.userfeedback.2.title") }}</label>
                  <label class="clearLabel">{{ t("products.userfeedback.2.position") }}</label>
                </p>
                <div class="user-logo-box">
                  <img id="userLogo" class="userLogo" src="/assets/images/user-feedback/2/logo.png" />
                </div>
              </div>
            </div>
            <div class="baukosten-box mt-3">
              <p class="brightfont" [innerHtml]="t('products.userfeedback.2.text1')"></p>
              <p class="brightfont d-inline hyphen mt-3" [innerHtml]="t('products.userfeedback.2.text2')"></p>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

    <ng-container>
      <app-reference></app-reference>
    </ng-container>

    <!-- Content Bar 06 - Beirat-->
    <!-- <div id="sectionId_advisoryboard"></div> -->
    <!--    <div #sectionId_advisoryboard id="sectionId_advisoryboard" ui-view="advisory_board">-->
    <!--      <app-advisory-board></app-advisory-board>-->
    <!--    </div>-->

    <!-- Content Bar 06 - Prices -->
    <!-- <div id="sectionId_prices"></div> -->
    <div #sectionId_prices id="sectionId_prices">
      <app-prices [showBuildingCosts]="showBuildingCosts" [backGroundColor]="'section-grey-color'"></app-prices>
    </div>
    <!-- STOP CONTENT -->
  </div>
</div>

<div class="kv-contact-btn" *transloco="let t">
  <!--Jobs -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/jobs">{{ t("global.footer.jobs") }}</a>
  </div>
  <!-- Book a Demo button -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/demo">{{ t("global.footer.demo") }}</a>
  </div>
  <!-- Contact button -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/contact">{{
      t("global.footer.contact")
    }}</a>
  </div>
</div>
